<template>
    <AddEtudiant />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddEtudiant from "@/components/Etudiant/AddEtudiant.vue";
  
    export default defineComponent({
      name: "AddEtudiantPage",
      components: {
        
        AddEtudiant,
      },
    });
  </script>